/* eslint-disable @typescript-eslint/no-explicit-any */
import Client from "../shared/services/Client";
import { SUBSCRIPTION_TYPE } from "common/constants/v2/Constants";

export default {
    /**
     * @returns {Promise}
     */
    setExpressCheckout(product: SUBSCRIPTION_TYPE): Promise<any> {
        let data = {};

        if (product === SUBSCRIPTION_TYPE.DIGITAL) {
            data = { NOSHIPPING: 1, REQBILLINGADDRESS: 1 };
        }

        return Client.post("/api/paypal/set-express-checkout", data).then(function(res: {token: string}): any {
            return res.token; // eslint-disable-line @typescript-eslint/no-unsafe-return
        });
    },

    /**
     * @param {String} token Ex. EC-5A862460HJ930725R
     * @returns {Promise}
     */
    createBillingAgreement(token: string): Promise<any> {
        return Client.post("/api/paypal/create-billing-agreement", {
            TOKEN: token
        });
    },

    /**
     * @param {String} token Ex. EC-5A862460HJ930725R
     * @returns {Promise}
     */
    getExpressCheckoutDetails(token: string): Promise<any> {
        return Client.post("/api/paypal/get-express-checkout-details", {
            TOKEN: token
        });
    },

    addPreAuthCharge(BAID: string, ratePlanId: string, numberOfUsers?: number): Promise<any> {
        return Client.post("/api/paypal/pre-auth", {
            BAID,
            ratePlanId,
            numberOfUsers
        });
    }

};
